import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, TrendingUp, TrendingDown, Receipt, Wallet, ArrowUpRight, Users } from "lucide-react";

const F = { fontFamily: "Barlow Condensed, sans-serif" };

export function PLSummaryCards({ data }) {
  const hasInvoices = data?.has_invoices;
  const totalRevenue = data?.total_revenue || 0;
  const totalExpenses = data?.total_expenses || 0;
  const netProfit = data?.net_profit || 0;
  const totalPaid = data?.total_paid || 0;
  const totalOutstanding = data?.total_outstanding || 0;
  const clientCount = data?.client_revenue?.length || 0;
  const avgPerEvent = data?.total_events ? Math.round(totalRevenue / data.total_events) : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <Card data-testid="revenue-total-card" className="stat-card">
        <CardContent className="p-5">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Revenue</span>
            <DollarSign className="w-4 h-4 text-primary" />
          </div>
          <p className="text-2xl font-bold text-primary" style={F}>${totalRevenue.toLocaleString()}</p>
          <p className="text-xs text-muted-foreground mt-1">{hasInvoices ? `${data?.total_invoice_count || 0} invoices` : `${data?.total_events || 0} events`}</p>
        </CardContent>
      </Card>

      <Card data-testid="expenses-total-card" className="stat-card">
        <CardContent className="p-5">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Expenses</span>
            <Receipt className="w-4 h-4 text-red-400" />
          </div>
          <p className="text-2xl font-bold text-red-400" style={F}>${totalExpenses.toLocaleString()}</p>
          <p className="text-xs text-muted-foreground mt-1">{data?.total_expense_count || 0} transactions</p>
        </CardContent>
      </Card>

      <Card data-testid="profit-card" className="stat-card">
        <CardContent className="p-5">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Net Profit</span>
            {netProfit >= 0 ? <TrendingUp className="w-4 h-4 text-emerald-400" /> : <TrendingDown className="w-4 h-4 text-red-400" />}
          </div>
          <p className={`text-2xl font-bold ${netProfit >= 0 ? "text-emerald-400" : "text-red-400"}`} style={F}>${netProfit.toLocaleString()}</p>
          <p className="text-xs text-muted-foreground mt-1">{totalRevenue > 0 ? `${Math.round((netProfit / totalRevenue) * 100)}% margin` : "No revenue yet"}</p>
        </CardContent>
      </Card>

      {hasInvoices ? (
        <>
          <Card data-testid="paid-card" className="stat-card">
            <CardContent className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Collected</span>
                <Wallet className="w-4 h-4 text-emerald-400" />
              </div>
              <p className="text-2xl font-bold text-emerald-400" style={F}>${totalPaid.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground mt-1">Payments received</p>
            </CardContent>
          </Card>
          <Card data-testid="outstanding-card" className="stat-card">
            <CardContent className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Outstanding</span>
                <ArrowUpRight className="w-4 h-4 text-amber-400" />
              </div>
              <p className="text-2xl font-bold text-amber-400" style={F}>${totalOutstanding.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground mt-1">Unpaid invoices</p>
            </CardContent>
          </Card>
        </>
      ) : (
        <>
          <Card className="stat-card">
            <CardContent className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Avg / Event</span>
                <TrendingUp className="w-4 h-4 text-blue-400" />
              </div>
              <p className="text-2xl font-bold" style={F}>${avgPerEvent.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground mt-1">Average event value</p>
            </CardContent>
          </Card>
          <Card className="stat-card">
            <CardContent className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Clients</span>
                <Users className="w-4 h-4 text-blue-400" />
              </div>
              <p className="text-2xl font-bold" style={F}>{clientCount}</p>
              <p className="text-xs text-muted-foreground mt-1">With revenue</p>
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
}
